enum ImageType {
  IMAGE_100 = 'image_100',
  IMAGE_SQUARE = 'image_square',
  IMAGE_CIRCLE = 'image_circle',
  IMAGE_RATIO = 'image_ratio',
  IMAGE_VIDEO = 'image_video',
}
export default ImageType;
